import React from "react";
import {
  WeaDialog,
  WeaLocaleProvider,
  WeaTop,
  WeaFormItem,
  WeaSearchGroup
} from "ecCom";
import WeaSwitch from "../../wea-switch";
import { toJS } from "mobx";
import { Button } from "antd";
import { inject, observer } from "mobx-react";
const getLabel = WeaLocaleProvider.getLabel;

@observer
class Main extends React.Component {
  constructor(props) {
    super(props);
  }

  getODItems = (form, datas, needTigger = true, hide) => {
    const { systemSetStore } = this.props;
    const { isFormInit } = form;
    let group = [];
    const formParams = form.getFormParams();
    isFormInit &&
      datas &&
      datas.map((c, index) => {
        let items = [];
        c.items.map(fields => {
          items.push({
            com: (
              <WeaFormItem
                viewAttr={fields.viewAttr}
                label={`${fields.label}`}
                labelCol={{ span: fields.labelcol }}
                wrapperCol={{ span: fields.fieldcol }}
                fieldType={fields.conditionType.toUpperCase()}
                error={form.getError(fields)}
                tipPosition="bottom"
              >
                <WeaSwitch
                  fieldConfig={fields}
                  form={form}
                  formParams={formParams}
                />
              </WeaFormItem>
            ),
            colSpan: 1,
            hide: false
          });
        });
        if (needTigger) {
          group.push(
            <WeaSearchGroup
              center={true}
              col={1}
              needTigger={needTigger}
              title={c.title}
              showGroup={c.defaultshow}
              items={items}
            />
          );
        } else {
          group.push(
            <WeaSearchGroup
              center={true}
              col={1}
              needTigger={needTigger}
              showGroup={c.defaultshow}
              items={items}
            />
          );
        }
      });
    return group;
  };
  onSaveOtherDetail = () => {
    const { systemSetStore } = this.props;
    const { oDForm } = systemSetStore;
    oDForm.validateForm().then(f => {
      if (f.isValid) {
        systemSetStore.saveDetail();
      } else {
        f.showErrors();
      }
    });
  };

  render() {
    const { systemSetStore } = this.props;
    const {
      otherDetailVisiable,
      dialogtitle,
      condition,
      oDForm,
      oDloading
    } = systemSetStore;
    return (
      <div>
        <WeaDialog
          title={toJS(dialogtitle).dialogtitle}
          loading={oDloading}
          icon={"icon-coms-Flow-setting"}
          iconBgcolor={"#407008"}
          hasScroll={true}
          style={{ width: 480, height: 180 }}
          visible={otherDetailVisiable}
          buttons={[
            <Button
              type="primary"
              onClick={() => {
                this.onSaveOtherDetail();
              }}
            >
              {getLabel(86, "保存")}
            </Button>,
            <Button
              type="ghost"
              onClick={() => {
                systemSetStore.setOtherDetailVisiable(false);
              }}
            >
              {getLabel(201, "取消")}
            </Button>
          ]}
          onCancel={() => {
            systemSetStore.setOtherDetailVisiable(false);
          }}
        >
          <div style={{ margin: 10, marginTop: 30 }}>
            {this.getODItems(oDForm, toJS(condition), true, false)}
          </div>
        </WeaDialog>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/otherDetailSet.js